import { SvgIcon, SvgIconProps } from '@mui/material'

const StationsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.45802 7C5.0223 7 4.63673 7.28213 4.50489 7.69742L2.91759 12.6974C2.72276 13.3111 3.14936 13.9366 3.77426 13.9955C3.60247 14.2907 3.50407 14.6338 3.50407 15V19C3.50407 20.1046 4.3995 21 5.50407 21H19.5041C20.6086 21 21.5041 20.1046 21.5041 19V15C21.5041 14.6338 21.4057 14.2907 21.2339 13.9955C21.8588 13.9366 22.2854 13.3111 22.0906 12.6974L20.5033 7.69742C20.3714 7.28213 19.9858 7 19.5501 7H5.45802ZM5.50407 15H19.5041V19H5.50407L5.50407 15Z"
        fill="currentColor"
      />
      <path
        d="M4.50407 4C4.50407 3.44772 4.95179 3 5.50407 3H19.5041C20.0564 3 20.5041 3.44772 20.5041 4C20.5041 4.55228 20.0564 5 19.5041 5H5.50407C4.95179 5 4.50407 4.55228 4.50407 4Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default StationsIcon
